export default [
  {
    title: "Flash Deal",
    customIcon: "FlashDealSVG",
    children: [
      {
        title: "Campaign List",
        path: "/flashdeal/privilege/campaign/list",
        route: "flashdeal-privilege-campaign-list",
      },
    ],
  },
];
